/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `child_profile` - Child profile * `child_profile_address` - Child profile address * `child_spz_recommendation` - Child SPZ recommendation * `child_support_measures` - Child support measures * `group` - Group
 */
export type HistoryModelTypeEnum = 'child_profile' | 'child_profile_address' | 'child_spz_recommendation' | 'child_support_measures' | 'group';

export const HistoryModelTypeEnum = {
    ChildProfile: 'child_profile' as HistoryModelTypeEnum,
    ChildProfileAddress: 'child_profile_address' as HistoryModelTypeEnum,
    ChildSpzRecommendation: 'child_spz_recommendation' as HistoryModelTypeEnum,
    ChildSupportMeasures: 'child_support_measures' as HistoryModelTypeEnum,
    Group: 'group' as HistoryModelTypeEnum
};